export default __webpack_public_path__ + "static/media/auto.8f9def81.svg";